import { useState, useEffect } from "react";
import styles from "./styles.module.scss";

const CountDown = ({ date, handleTimeout }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [expired, setExpired] = useState(false);

  function calculateTimeLeft() {
    const difference = +date - Date.now();
    if (difference <= 0) {
      return { hours: 0, minutes: 0, seconds: 0, expired: true };
    }
    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    return { hours, minutes, seconds, expired: false };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.expired) {
        setExpired(true);
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [date]);

  useEffect(() => {
    if (expired) {
      handleTimeout();
      // Don't navigate here - let the parent component handle navigation
      localStorage.setItem("secondsLeft", "0");
    } else {
      const secondsLeft = timeLeft.hours * 3600 + timeLeft.minutes * 60 + timeLeft.seconds;
      localStorage.setItem("secondsLeft", secondsLeft.toString());
    }
  }, [expired, timeLeft, handleTimeout]);

  if (expired) return null;

  const { hours, minutes, seconds } = timeLeft;

  return (
    <div className={`${styles.timer} ${styles.timerContainer}`}>
      <div className={`${styles.hours} ${styles.timeBtn} ${styles.hoursBtn}`}>
        <p className={styles.timeValue}>{String(hours).padStart(2, "0")}</p>
        <span className={styles.timeLabel}>hours</span>
      </div>
      <div className={`${styles.minutes} ${styles.timeBtn} ${styles.minutesBtn}`}>
        <p className={styles.timeValue}>{String(minutes).padStart(2, "0")}</p>
        <span className={styles.timeLabel}>mins</span>
      </div>
      <div className={`${styles.seconds} ${styles.timeBtn} ${styles.secondsBtn}`}>
        <p className={styles.timeValue}>{String(seconds).padStart(2, "0")}</p>
        <span className={styles.timeLabel}>secs</span>
      </div>
    </div>
  );
};

export { CountDown };